<i18n src="../../locales/lang.json"></i18n>
<template>
  <div class="container-fluid">
    <div>
      procedure material
    </div>
  </div>
</template>

<script>


  export default {
    name: "procedure-materialmode",
    components: {
      
    },
    props: {
      
      mode: {
        required: false,
        type: String,
        default: "edit"
      }
    },
    data() {
      return {
        
      };
    },
    
    methods: {
      handleRefresh(val) {
        this.$forceUpdate();
      }
    },
    computed: {
      procedure: {
        get() {
          return this.$store.state.procedure;
        },
        set(value) {
          //alert("updateprocedure 14");
          this.$store.commit('saveprocedure', value)
        }
      }
    },
    mounted() {

    },

    created: function () {

    },

    watch: {
     
    },
    created() {
      this.$root.$on('procedure_refresh', this.handleRefresh);
    },
  };

</script>



// WEBPACK FOOTER //
// src/components/procedure/procedure-materialmode.vue